<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover; color: #fff;background: #007cef;">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%">
                            <h1 class="custom-header-title text-center">
                                <strong>Contact Us</strong>
                            </h1>
                            <h3 class="mt-3 mb-4 text-white custom-header-subtitle text-center poppin-font">
                                Welcome to Pickiddo Campus, your ultimate destination for upskilling.<br />
Join our dynamic training classes, where we offer training materials and expert instructors to accelerate and <br />
 enhance your learning with impactful results.</h3>
                            <br>
                        </div>
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-grey">
    
            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
                <CRow>
                    <CCol sm="6">
                        <CCard class="bg-white mt-5 b-20" style="border:none">
                            <h1 class="custom-header-title text-black text-left text-48px mt-5">
                                <strong>Reach Us</strong>
                            </h1>
                            <label class="custom-header-subtitle text-left text-16px p-40">Fill out the form and our team will get back to you within 24 hours.</label>
                            <CRow class="p-40 mb-20">
                                <CCol sm="2"><img style="max-width:100%" src="../assets/img/bell.png" /></CCol>
                                <CCol sm="10">
                                    <h5 class="text-16px text-black-dark mt-2">+6010 6597700</h5>
                                </CCol>
    
    
                                <CCol sm="2" class="mt-2"><img style="max-width:100%" src="../assets/img/email.png" /></CCol>
                                <CCol sm="10" class="mt-2">
                                    <h5 class="text-16px text-black-dark mt-2">support@pickiddo.com</h5>
                                </CCol>
    
                                <CCol sm="2" class="mt-2"><img style="max-width:100%" src="../assets/img/location.png" /></CCol>
                                <CCol sm="10" class="mt-2">
                                    <h5 class="text-16px text-black-dark mt-2">The Square @ One City, T1-14-13, Jalan USJ 25/1C, 47650 Subang Jaya, Selangor</h5>
                                </CCol>
                          
                            </CRow>
                            <br /><br />      
                        </CCard>
                    </CCol>
                    <CCol sm="6">
                        <CCard class="bg-white mt-5 p-40 b-20" style="border:none">
                            <label class="text-black-dark mt-3">Name</label> 
                            <CInput type="text" class="custom-input b-50" />

                            <label class="text-black-dark">Email</label> 
                            <CInput type="text" class="custom-input b-50" />

                            <label class="text-black-dark">Contact Number</label> 
                            <CInput type="text" class="custom-input b-50" />

                            <label class="text-black-dark">How can we help you?</label> 
                            <CTextarea type="text"
                rows="9"/>
                <div class="text-right mb-4">
                    <CButton class="button-Explore-dark bg-main-blue" style="width:50%;background-color: #027DEF;width:100px"><span class="ml-2 mr-2">Send</span></CButton>
                </div>
               
                        </CCard>
                    </CCol>
                </CRow>
    
            </CCol>
    
        </CCol>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap

        };
    },
    created() {
        AOS.init();
    },

};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>